import { ApprovalOrderItemResponse } from './approval-process-modal-business';

export interface ApprovalProcessParams {
  approvalSeq?: number | string,
  approvalProcessSeq?:  number | string,
  orderType?: string,
  documentNumber?: number,
  purchaseRequestNumber?:  number,
  approveOrderItemResponse?: ApprovalOrderItemResponse,
  typeInterfaceIntegration?: string,
  descriptionDialog?: string,
}

export default class ApprovalProcess {
  private static params: ApprovalProcessParams;

  public static get(): ApprovalProcessParams {
    return this.params;
  }

  public static set(param: ApprovalProcessParams): void {
    this.params = param;
  }
}
